import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  setOnboardingStatus,
  useOnboardingStatus,
} from "../components/Onboarding/Onboarding";
import { getSupaClient } from "../lib/supabase";

/**
 * Component that renders when being redirected from OAuth sign in on the /signup page, e.g. Google auth
 */
export default function OAuthSignUp() {
  const navigate = useNavigate();
  useEffect(() => {
    getSupaClient().auth.onAuthStateChange((event) => {
      if (event === "SIGNED_IN") {
        const user = getSupaClient().auth.user();
        if (user?.email) {
          setOnboardingStatus(user.email, "choose-platform");
          // redirect to / instead of /onboarding in case this user already signed up before
          navigate("/");
        }
      }
    });
  }, []);
  return <div className="m-8">Redirecting...</div>;
}
